import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=10a1e7e9&scoped=true&"
import script from "./Staff.vue?vue&type=script&lang=js&"
export * from "./Staff.vue?vue&type=script&lang=js&"
import style0 from "./Staff.vue?vue&type=style&index=0&id=10a1e7e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1e7e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a1e7e9')) {
      api.createRecord('10a1e7e9', component.options)
    } else {
      api.reload('10a1e7e9', component.options)
    }
    module.hot.accept("./Staff.vue?vue&type=template&id=10a1e7e9&scoped=true&", function () {
      api.rerender('10a1e7e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Staff.vue"
export default component.exports